(function ($) {
    $('.tab-select').on('click', function () {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        $('.tab-content').removeClass('active');
        $('.tab-content[data-tab-select="' + $(this).attr('data-tab') + '"]').addClass('active');
    });

})(jQuery);